import ConfirmActionPopup from 'components/ConfirmActionPopup';
import React, { Component } from 'react';

interface Props {
  disabled?: boolean,
  popupMessage?: string,
  trigger?: React.ReactNode,
  poperDependencies?: any[],
  onConfirm: () => void,
  onOpen?: () => void,
  position?: string
}

interface State {
}

class DiscardOrderChangesActionButton extends Component<Props, State> {

  render(): React.ReactNode {
    const {
      disabled = false,
      popupMessage,
      poperDependencies,
      onOpen,
      onConfirm,
      trigger,
      position
    } = this.props;

    if (popupMessage) {
      return (
          <ConfirmActionPopup
              message={popupMessage}
              renderTarget={trigger}
              poperDependencies={poperDependencies}
              onConfirmAction={onConfirm}
              onOpen={onOpen}
              disabled={disabled}
              position={position}
          />
      );
    }
  }

}

export default DiscardOrderChangesActionButton;
